// web/src/components/PullQuote.tsx
// Match notes treated as a pull quote in italic Fraunces, with a big serif
// quote glyph at the left. Replaces the previous "muted blockquote with a
// gold line" style. Optional attribution shown in small caps below.

import type { ReactNode, CSSProperties } from 'react';

export interface PullQuoteProps {
  children: ReactNode;
  attribution?: string;
  /** Tint variant: 'paper' (warm cream) or 'plain'. */
  surface?: 'paper' | 'plain';
  style?: CSSProperties;
}

export function PullQuote({ children, attribution, surface = 'paper', style }: PullQuoteProps) {
  return (
    <blockquote
      style={{
        margin: '0',
        padding: 'var(--space-lg) var(--space-base)',
        background: surface === 'paper' ? 'var(--surface-2)' : 'transparent',
        borderRadius: 'var(--radius-md)',
        borderLeft: '3px solid var(--gold)',
        position: 'relative',
        ...style,
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'absolute',
          left: 6,
          top: -6,
          fontFamily: 'var(--font-display)',
          fontSize: '4rem',
          lineHeight: 1,
          color: 'var(--gold)',
          opacity: 0.5,
        }}
      >
        “
      </span>
      <p
        style={{
          margin: 0,
          paddingLeft: 'var(--space-lg)',
          fontFamily: 'var(--font-display)',
          fontStyle: 'italic',
          fontSize: 'var(--lede)',
          lineHeight: 1.55,
          color: 'var(--ink)',
          whiteSpace: 'pre-wrap',
        }}
      >
        {children}
      </p>
      {attribution ? (
        <footer
          style={{
            marginTop: 'var(--space-sm)',
            paddingLeft: 'var(--space-lg)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--micro)',
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--muted)',
          }}
        >
          — {attribution}
        </footer>
      ) : null}
    </blockquote>
  );
}
